import CellHOC from '@platform/react/hoc/list/cell'
import Text from 'ui/Element/Text'

/**
 * Displays the measurement's frequency.
 *
 * @param {Object} classes  styling for the cell
 * @param {Object} props    props for the cell
 *
 * @returns {JSX.Element}
 */
const ListItemCellXEcoApmFrequency = (classes, props = {}) => {
  const { frequency = '-' } = props
  const frequencyWithUnit = `${frequency} kHz`

  return (
    <Text
      color={'black'}
      variant={'14/regular'}
      className={classes.row}
    >
      {frequencyWithUnit}
    </Text>
  )
}

export default CellHOC(ListItemCellXEcoApmFrequency)
